import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=5e2495ac&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=5e2495ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2495ac",
  null
  
)

export default component.exports